import { Assign } from '@doist/icons/product-ui';
import { Box, Stack } from '@doist/marketist';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIAvatar } from '../product-ui-avatar/product-ui-avatar';
import { ProductUIContextMenu } from '../product-ui-context-menu/product-ui-context-menu';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem } from '../product-ui-list-item';
import { useProductUINSTranslation } from '../product-ui-ns-context';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskAttributeButton } from '../product-ui-task-attribute-button/product-ui-task-attribute-button';
import { ProductUIView } from '../product-ui-view/product-ui-view';
export function AssignResponsibility() {
  const {
    t
  } = useProductUINSTranslation();
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="AssignResponsibility" data-sentry-source-file="assign-responsibility.tsx">
            <ProductUISceneLayer position="bottomLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="assign-responsibility.tsx">
                <ProductUIAppWindow inlineSize={800} blockSize="calc(100% + 7px)" showSidebar sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="board">
                                <ProductUIView.Header title={t('sequence.assignResponsibility.marketingPractices')} breadcrumbs={[t('team'), t('sequence.assignResponsibility.companyPractices')]} />

                                <ProductUIView.BoardView>
                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.assignResponsibility.listEachProperty')}
                                        </ProductUIView.SectionTitle>

                                        <ProductUITask variant="board" hovered hoveredSection={<ProductUITask.AttributeButtonContainer>
                                                    <ProductUITaskAttributeButton size="base">
                                                        <ProductUIAvatar size={18} character="anais" />
                                                    </ProductUITaskAttributeButton>
                                                </ProductUITask.AttributeButtonContainer>}>
                                            <ProductUITask.Text>
                                                {t('sequence.assignResponsibility.listOn')}{' '}
                                                <span style={{
                    textDecoration: 'underline'
                  }}>
                                                    {t('sequence.assignResponsibility.zillow')}
                                                </span>
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                        <ProductUITask hovered={true} hoveredSection={<ProductUITask.AttributeButtonContainer>
                                                    <Box>
                                                        <ProductUITaskAttributeButton hovered={true} size="base">
                                                            <Assign />
                                                        </ProductUITaskAttributeButton>
                                                    </Box>
                                                </ProductUITask.AttributeButtonContainer>} variant="board" contextMenu={<ContextMenu />}>
                                            <ProductUITask.Text>
                                                {t('sequence.assignResponsibility.listOn')}{' '}
                                                <span style={{
                    textDecoration: 'underline'
                  }}>
                                                    {t('sequence.assignResponsibility.realtor')}
                                                </span>
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.assignResponsibility.socialMediaLogins')}
                                        </ProductUIView.SectionTitle>

                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="40" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="60" />
                                        </ProductUITask>
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.assignedTasks.readyforqa')}
                                        </ProductUIView.SectionTitle>

                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                    </ProductUIView.Section>
                                </ProductUIView.BoardView>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="assign-responsibility.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
function ContextMenu() {
  const {
    t
  } = useProductUINSTranslation();
  return <ProductUIContextMenu placement={{
    top: 48,
    right: 10
  }} width={170} data-sentry-element="ProductUIContextMenu" data-sentry-component="ContextMenu" data-sentry-source-file="assign-responsibility.tsx">
            <Stack gap="2" data-sentry-element="Stack" data-sentry-source-file="assign-responsibility.tsx">
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="denise" />} label={t('sequence.assignedTasks.me')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assign-responsibility.tsx" />
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="anais" />} label={t('characters.anais')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assign-responsibility.tsx" />
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="naomi" />} label={t('characters.naomi')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assign-responsibility.tsx" />
                <ProductUICursorContainer size="lg" data-sentry-element="ProductUICursorContainer" data-sentry-source-file="assign-responsibility.tsx">
                    <ProductUIBasicListItem hovered={true} icon={<ProductUIAvatar size={20} character="paul" />} label={t('characters.paul')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assign-responsibility.tsx" />
                </ProductUICursorContainer>
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="pawel" />} label={t('characters.pawel')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assign-responsibility.tsx" />
            </Stack>
        </ProductUIContextMenu>;
}